import type { FC } from 'react';
import StarBorderRounded from '@mui/icons-material/StarBorderRounded';
import StarRounded from '@mui/icons-material/StarRounded';
import { Box, IconButton, TableCell } from '@mui/material';

import { useSurveyList } from 'src/components/survey/SurveyContext/ListContext';
import type { CellProps } from 'src/components/survey/SurveySelectionPage/components/SurveyTableView/types';

import { styles } from './cell.styles';

export const SURVEY_TABLE_FAVORITE_TEST_ID = 'survey-table-favorite';

const FavoriteCell: FC<CellProps> = ({ columns, survey }) => {
  const { toggleFavoriteSurvey } = useSurveyList();
  const handleToggleFavorite = (surveyId: number) => () =>
    toggleFavoriteSurvey(surveyId);

  return (
    <TableCell
      sx={styles.cell(columns.isFavorite.width)}
      data-test-id={SURVEY_TABLE_FAVORITE_TEST_ID}
      padding="none"
    >
      {survey.isFavorite ? (
        <IconButton onClick={handleToggleFavorite(survey.id)}>
          <StarRounded sx={styles.favoriteMarked} />
        </IconButton>
      ) : (
        <IconButton onClick={handleToggleFavorite(survey.id)}>
          <Box sx={styles.favorite}>
            <StarBorderRounded />
            <StarRounded />
          </Box>
        </IconButton>
      )}
    </TableCell>
  );
};

export default FavoriteCell;
